/**
 * @typedef {Object} PatientPageDataProps
 * @property {string} name - The unique name of the page.
 * @property {string|string[]} path - The path/URL(s) to the page.
 * @property {number} [groupId] - The group ID for the page, used for grouping in the header navigation.
 * @property {JSX.Element} [headerNavigationLabel] - The label for the page in the header navigation.
 * @property {JSX.Element} [headerSubNavigationLabel] - The label for the page in the sub navigation.
 */

/**
 * @description This file contains the page data for the patient section of the site.
 * It includes the name, path, title, header navigation label, and group ID for each page.
 *
 * @returns {PatientPageDataProps[]} An array of objects representing the page navigation data.
 */

/** @type {PatientPageDataProps[]} */
const patientPageData = [
  {
    name: 'patient',
    path: '/',
  }, {
    name: 'patient-about-cah-cah-101',
    path: '/cah-101',
    headerNavigationLabel: <span className="text-nowrap">About CAH</span>,
    headerSubNavigationLabel: <>CAH 101</>,
    groupId: 1,
  }, {
    name: 'patient-about-cah-symptoms',
    path: '/symptoms',
    headerNavigationLabel: <span className="text-nowrap">About CAH</span>,
    headerSubNavigationLabel: <>Symptoms</>,
    groupId: 1,
  }, {
    name: 'patient-science-of-cah',
    path: '/science-of-cah',
    headerNavigationLabel: <span><span className="text-nowrap">The Science</span> <span className="text-nowrap">of CAH</span></span>,
    groupId: 2,
  }, {
    name: 'patient-managing-cah-steroids',
    path: '/steroids-in-cah',
    headerNavigationLabel: <>Managing CAH</>,
    headerSubNavigationLabel: <>Steroids in CAH</>,
    groupId: 3,
  }, {
    name: 'patient-managing-cah-different-way',
    path: '/manage-androgens',
    headerNavigationLabel: <>Managing CAH</>,
    headerSubNavigationLabel: <>A Different Way to Manage Androgens</>,
    groupId: 3,
  }, {
    name: 'patient-resources-videos-and-downloads',
    path: '/resources',
    headerNavigationLabel: <>Resources</>,
    headerSubNavigationLabel: <>Videos & Downloads</>,
    groupId: 4,
  }, {
    name: 'patient-resources-find-endocrinologist',
    path: '/find-an-endo',
    headerNavigationLabel: <>Resources</>,
    headerSubNavigationLabel: <>Find an Endocrinologist</>,
    groupId: 4,
  }, {
    name: 'patient-resources-life-hacks-tips',
    path: '/life-hacks',
    headerNavigationLabel: <>Resources</>,
    headerSubNavigationLabel: <>Life Hacks & Tips</>,
    groupId: 4,
  }, {
    name: 'patient-wtcah-community-moments',
    path: '/moments',
    headerNavigationLabel: <>WTC@H?! Community</>,
    headerSubNavigationLabel: <>WTC@H?! Moments</>,
    groupId: 5,
  }, {
    name: 'patient-wtcah-community-social',
    path: '/social',
    headerNavigationLabel: <>WTC@H?! Community</>,
    headerSubNavigationLabel: <>WTC@H?! on Social</>,
    groupId: 5,
  }, {
    name: 'patient-wtcah-community-ambassadors',
    path: '/ambassadors',
    headerNavigationLabel: <>WTC@H?! Community</>,
    headerSubNavigationLabel: <>WTC@H?! Ambassadors</>,
    groupId: 5,
  }, {
    name: 'patient-stay-connected',
    path: '/stay-connected',
    headerNavigationLabel: <>Stay Connected</>,
    groupId: 6,
  }, {
    name: 'patient-sitemap',
    path: '/sitemap',
  },{
    name: 'error-404',
    path: '*',
  }
];

/**
 * @description This function filters the patientPageData to return only the pages that have a headerNavigationLabel defined.
 * It maps over the filtered pages to create an array of objects with groupId, name, subName, and path properties.
 * 
 * @returns {Array} An array of objects representing the header navigation items for the patient section.
 */
const patientHeaderNavegationItems = patientPageData.filter((page) => page.headerNavigationLabel !== undefined).map((page) => {
  return {
    groupId: page.groupId,
    name: page.headerNavigationLabel,
    subName: page.headerSubNavigationLabel,
    path: page.path,
  }
});
export {patientPageData as default, patientHeaderNavegationItems};